import { ActionBase } from './action-base';
import { type } from '../../shared/components/helpers/util';
import { FeatureConfig  } from '../../../lib/angular/model/dealer/feature-config';

/**
 * Dealer Option Action Types
 */
export const FEATURE_CONFIG_ACTION = {
  LOAD: type('FEATURE_CONFIG_LOAD'),
  SET: type('FEATURE_CONFIG_SET'),
  CLEAR: type('FEATURE_CONFIG_CLEAR')
};

/**
 * FeatureConfigActionLoad
 */
export class FeatureConfigActionLoad implements ActionBase {
  public readonly type: string = FEATURE_CONFIG_ACTION.LOAD;
  constructor() {}
}

/**
 * DealerOptionActionSet
 */
export class FeatureConfigActionSet implements ActionBase {
  public readonly type: string = FEATURE_CONFIG_ACTION.SET;
  constructor(public payload: FeatureConfig[]) {}
}


/**
 * FeatureConfigActionClear
 */
export class FeatureConfigActionClear implements ActionBase {
  public readonly type: string = FEATURE_CONFIG_ACTION.CLEAR;
  constructor() {}
}

export type Any = FeatureConfigActionLoad |
FeatureConfigActionClear |
FeatureConfigActionSet;
